import React from 'react';

import styled from 'styled-components';

import { Carousel, Button } from '@zanichelli/react-components';

const LeftImage = styled.div`
    height: 100%;
    min-height: 256px;

    background-image: url(${props => props.src});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
`;

const RightContainer = styled.div`
    max-width: 504px;
    padding: 32px 16px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    @media (max-width: 991px) {
        text-align: center;
        align-items: center;
        margin: auto;
    }

    @media (min-width: 992px) {
        height: 512px;
    }
`;

const Title = styled.h2`
    margin: 16px 0;
    font-weight: bold;

    @media (max-width: 991px) {
        font-size: 24px;
        margin: 0 0 16px 0;
    }
`;

const RightIcon = styled.img`
    height: 96px;

    @media (max-width: 991px) {
        display: none !important;
    }
`;

const Paragraph = styled.p`
    margin-bottom: 16px;
`;

const Grid = styled.div`
    display: grid;

    grid-template-columns: auto calc(100 / 12 * 5%);

    @media (max-width: 991px) {
        grid-template-columns: auto;
    }
`;

const contents = [
    {
        images: {
            main: '/_assets/images/landingV2/exercize_screen.png',
            icon: '/_assets/images/landingV2/icon_03_teacher.svg'
        },
        title: 'Cerca tra gli esercizi già presenti o creane di nuovi',
        text:
            "Puoi usare esercizi già pronti, cercandoli nell'archivio per: argomento, libro di testo, o tipologia di esercizio! In Crea Verifiche trovi anche gli esercizi presenti nei libri Idee per insegnare con tanti esempi di esercizi divisi per capitolo! Oppure puoi crearne di nuovi!",
        buttonText: 'Vai a esercizi'
    },
    {
        images: {
            main: '/_assets/images/landingV2/export_screen.png',
            icon: '/_assets/images/landingV2/icon_02_teacher.svg'
        },
        title: 'Cerca tra le verifiche pronte, esportale e stampale per la tua classe',
        text:
            "Trovi le verifiche del tuo libro e tante altre della tua materia, puoi usare l'opzione di esportazione rapida in Word/PDF, con versioni ad alta leggibilità o esportazione verifiche randomizzate.",
        buttonText: 'Vai al tuo archivio'
    },
    {
        images: {
            main: '/_assets/images/landingV2/archive_screen.png',
            icon: '/_assets/images/landingV2/icon_01_student.svg'
        },
        title: 'Salva e riutilizza quando vuoi i tuoi esercizi e le tue verifiche',
        text: 'Salva le verifiche e gli esercizi nel tuo archivio, ritrovi tutto per il prossimo anno.',
        buttonText: 'Vai al tuo archivio'
    }
];

const Main = () => {
    return (
        <Carousel>
            {contents.map(({ images, title, text, buttonText }, index) => (
                <Grid key={index}>
                    <LeftImage src={images.main} />
                    <RightContainer>
                        <RightIcon src={images.icon} alt="" />
                        <Title>{title}</Title>
                        <Paragraph>{text}</Paragraph>
                        <Button shape="square" type="primary" label={buttonText} />
                    </RightContainer>
                </Grid>
            ))}
        </Carousel>
    );
};

export default Main;
